import { CustomAutocomplete, CustomTextField, CustomTextFieldNoForm, LoaderComponent, SingleButton, TabTextLabel } from "@/shared/components/ui";
import { Grid, Paper, Typography } from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate, useParams } from "react-router-dom";
import { BucketAwtENUM, EstadosProcesoEnumChoice, gridSize, gridSizeMdLg4, gridSizeMdLg8, ModulosEnumChoice, ROUTER_PATHS, texto, useUploadFile } from "@/shared";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { updateOrdenesCompra, useFetchMotivosRechazo, useGetOrdenesCompra, useUpdateOrdenesCompra, useUpdateProveedor } from "@/shared/actions/erp";
import ActionsBar from "@/shared/components/ui/ActionBar";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";

import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useEffect, useState } from "react";
import ModalObservacionNoForm from "@/shared/components/ui/ModalObservacionNoForm";
import { useFieldArray, useForm } from "react-hook-form";
import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada";
import { AlertSeverityEnum, MaterialTransferido, MotivoRechazo } from "@/shared/interfaces";

import { useUiStore } from "@/store/ui";
import { useFileDowloadDoc } from "@/shared/hooks/useDownloadFileDoc";
import { useFilePrint } from "@/shared/hooks/usePrintFile";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import useRevisionOrdenCompra from "../../shared/hook/useRevisionOrdenCompra";
import CustomEmailDialog from "@/shared/components/ui/CustomEmailDialog/CustomEmailDialog";
import { ensurePdfUrl } from "./ensurePdfUrl";


export default function RevisionOrdenesComprasPage() {
  const { id } = useParams()
  ///store
  const productos = useCargarSeriesProductos(s => s.productos)
  //const total
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const setAlert = useUiStore(s => s.setAlert)
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  //const setConfirmDialogIsOpen2 = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  //console.log('prod', productos)
  const navigate = useNavigate()
  //state
  const [idEdit, setIdEdit] = useState('')
  const [editableIndex, setEditableIndex] = useState<number | null>(null)
  //Fetch
  const {
    data: dataOrdenCompra, isLoading, refetch
  } = useGetOrdenesCompra(id!)

  const updateOrdenesCompras = useUpdateOrdenesCompra({
    navigate,
    returnUrl: ROUTER_PATHS.compras.orden_compras_nav
  })

  const {
    data: dataMotivoRechazo, isLoading: isLoadingMotivo,
  } = useFetchMotivosRechazo({
    page_size: 600,
    modulo: ModulosEnumChoice.COMPRAS
  })
  //update_proveedor
  const updateProveedor = useUpdateProveedor({ navigate })
  //console.log(dataMotivoRechazo)
  ///hook
  const { infoProductos } = useRevisionOrdenCompra()
  const { handleUploadFile } = useUploadFile()
  const { downloadFile } = useFileDowloadDoc()
  const { printFile } = useFilePrint()

  ////gitstate
  const [archivo, setArchivo] = useState<File | null>(null)
  const [isOpeModalRechazo, setIsOpenModalRechazo] = useState(false)
  //
  const [isOpenModal2, setIsOpenModal2] = useState(false)
  //const [emailsProveedor, setEmailsProveedor] = useState<string[]>([])
  //console.log('emails', emailsProveedor)
  //useEffect
  useEffect(() => {
    if (isLoading) return
    const aux = dataOrdenCompra?.data.detalles!.map(({ cantidad_pendiente, ...item }: MaterialTransferido) => ({
      ...item,
      cantidad_aprobada: Number(item.cantidad)
    }))
    handleCopiarLista(aux!)
  }, [dataOrdenCompra])
  //form
  type SaveFormData = {
    motivo_rechazo: string;
    observaciones?: {
      observacionCreador?: string;
      observacionRevisor?: string;
    }
    cantidad_aprobada: number;
    correos?: { name: string, isEditable: boolean, isAutomatic: boolean }[]
  }
  const form = useForm<SaveFormData>({
    defaultValues: {
      correos: []
    }
  });
  const {
    control,
    formState: { errors },
  } = form;
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: "correos"
  })

  //****download */
  const handleDowload = async () => {
   
    const url = await ensurePdfUrl({
      dataOrdenCompra,
      updateOrdenesCompra,
    });
    if (!url) return
    downloadFile({
      //url: dataOrdenCompra?.data?.url_pdf,
      url: url!,
      nameFile: "orden_compra",
      extensionFile: "pdf"
    })
  }

  //****Print */
  const handlePrint = async () => {
    //if (!dataOrdenCompra?.data?.url_pdf) return setAlert(true, 'No dispone ningun orden.', AlertSeverityEnum.info)
    const url = await ensurePdfUrl({
      dataOrdenCompra,
      updateOrdenesCompra,
    });

    if (!url) return;
    
    printFile({
      urlPdf: url
    })
  }

  ///useEffect
  useEffect(() => {
    if (!dataOrdenCompra) return;

    const proveedorEmails: { name?: string, isEditable: boolean, isAutomatic: boolean }[] = [];

    const proveedor = dataOrdenCompra.data.proveedor_data;
    setIdEdit(proveedor?.id_proveedor!)
    // Puedes agregar todos los emails que existan
    if (proveedor?.email) proveedorEmails.push({ name: proveedor.email, isEditable: true, isAutomatic: true });
    if (proveedor?.contacto_email_1) proveedorEmails.push({ name: proveedor.contacto_email_1, isEditable: true, isAutomatic: true });
    if (proveedor?.contacto_email_2) proveedorEmails.push({ name: proveedor.contacto_email_2, isEditable: true, isAutomatic: true });

    // Si no hay ningún correo, dejamos un campo vacío
    if (proveedorEmails.length === 0) proveedorEmails.push({ name: "", isEditable: false, isAutomatic: true });

    // Resetear el form con los correos iniciales
    form.reset({
      ...form.getValues(), // mantener otros valores
      correos: proveedorEmails
    });

  }, [dataOrdenCompra]);



  ///**********UPDATE */
  const onSaveUpdate = async (emailsProveedor?: string[]) => {
    const campoInvalido = productos.find(item => item.cantidad_aprobada! <= 0)
    if (campoInvalido) {
      setAlert(true, `El producto "${campoInvalido.codigo}", tiene una cantidad aprobada inválida, debe ser mayor a cero.`, AlertSeverityEnum.error)
      return;
    }
    const isImage = archivo?.type.startsWith("image/")
    const bucketDestino = isImage
      ? BucketAwtENUM.IMAGE_REVISION_ORDEN
      : BucketAwtENUM.DOCUMENTO_REVISION_ORDEN_COMPRA
    const archivoRevision = (await handleUploadFile(archivo!, bucketDestino)).url;

    const urlsActual = dataOrdenCompra?.data?.urls_imagenes || {}
    const observacionActual = dataOrdenCompra?.data?.observaciones || {}

    const revisionOrdenCompra: any = {
      id: id,
      data: {
        estado_orden: EstadosProcesoEnumChoice.ABIERTO,
        detalles: productos,
        observaciones: {
          ...observacionActual,
          observacionRevisor: form.getValues().observaciones?.observacionRevisor
        },
        urls_imagenes: {
          ...urlsActual,
          urlOrdenRevision: archivoRevision,
        },
        emails: emailsProveedor
      }
    }
    //console.log('revision', revisionOrdenCompra)
    //return
    try {
      const result = await updateOrdenesCompras.mutateAsync(revisionOrdenCompra)
      if (result.code !== 200) return;
      navigate(ROUTER_PATHS.compras.orden_compras_nav)
      clearSelectedItems()
    } catch (error) {
      console.error("Error en la mutación", error)
    }

  }
  ///orden Pedido rechazado
  const handleUpdateMotivo = () => {

    if (form.getValues().motivo_rechazo === "") {
      setAlert(true, "Seleccione un motivo, para proceder con la confirmación.", "error")
      return;
    }
    const observacionActual = dataOrdenCompra?.data?.observaciones || {}
    const ordenComprasRechazo = {
      id: id,
      data: {
        estado_orden: EstadosProcesoEnumChoice.CANCELADO,
        motivo_rechazo: form.getValues().motivo_rechazo,
        observaciones: {
          ...observacionActual,
          observacionRevisor: form.getValues().observaciones?.observacionRevisor

        }
      }
    } as any
    //console.log('ordenCompra', ordenComprasRechazo)

    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Está seguro de que deseas Rechazar el orden de compra seleccionada?. Esta accción no se puede deshacer. ",
      title: "¡ Confirmar !",
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm: async () => {
        try {
          setConfirmDialogIsOpen(false)
          const resp = await updateOrdenesCompras.mutateAsync(ordenComprasRechazo)
          if (resp.code !== 200) return;
          navigate(ROUTER_PATHS.compras.orden_compras_nav)


        } catch (error) {
          console.log(error)
        }


      },

    })
  }
  //**
  if (isLoading) return <LoaderComponent />

  return (
    <>

      <Typography variant="h5">{'REVISIÓN DE ORDEN DE PEDIDO'}</Typography>
      <Grid container spacing={1}>
        <Grid item xs={12} spacing={1} container justifyContent={'flex-end'}>
          <Grid item>
            <SingleButton
              label="Volver"
              variant="outlined"
              startIcon={<ArrowBackIosIcon />}
              onClick={() => { navigate(ROUTER_PATHS.compras.orden_compras_nav) }}
            />
          </Grid>
          <Grid item>
            <SingleButton
              label="Aprobar"
              variant="outlined"
              color={"success"}
              startIcon={<CheckCircleOutlineIcon />}
              onClick={() => {
                setIsOpenModal2(true)
                //onSaveUpdate()
              }}
            />
          </Grid>
          <Grid item>
            <SingleButton
              label="Rechazar"
              variant="outlined"
              color="error"
              startIcon={<HighlightOffIcon />}
              onClick={() => { setIsOpenModalRechazo(true) }}
            />
          </Grid>
        </Grid>
        <Grid item {...gridSize} spacing={3} container mt={1}>
          <ModalObservacionNoForm
            label='Observación del Solicitante (Bodega)'
            //texto={dataOrdenCompra?.data.solicitud_ingreso_data?.observaciones.observacionSolicitante || 'N/A'}
            texto={dataOrdenCompra?.data.solicitud_ingreso_data?.observaciones?.observacionSolicitante || 'N/A'}
            title='Observación'
            size={gridSizeMdLg4}
            numbertextPreview={20}
          />

          <CustomTextFieldNoForm
            label="Nombre Proveedor"
            defaultValue={dataOrdenCompra?.data.proveedor_data?.razon_social}
            size={gridSizeMdLg4}
          />
          <CustomTextFieldNoForm
            label="Email Proveedor"
            value={dataOrdenCompra?.data.proveedor_data?.email || 'N/A'}
            size={gridSizeMdLg4}

          />
          <CustomTextFieldNoForm
            label="Teléfono Proveedor"
            defaultValue={dataOrdenCompra?.data.proveedor_data?.contacto_telefono_1 || 'N/A'}
            size={gridSizeMdLg4}
          />
          <CustomTextField
            label={texto.observacion}
            name='observaciones.observacionRevisor'
            control={form.control}
            error={errors.observaciones?.observacionRevisor}
            helperText={errors.observaciones?.observacionRevisor?.message}
            required={false}
            size={gridSizeMdLg8}
          />
          <Grid item xs={12}>
            <TabTextLabel text={'Respaldo de aprobación'} mt={0} pb={0} pl={0} pt={2} />
          </Grid>
          <Grid item {...gridSizeMdLg4}>
            <CargarDocumentoSoluccionCosteada
              idInput='documento-solicitud_compra'
              buttonText={'Subir Respaldo de Aprobación'}
              selectedImage={archivo}
              setSelectedImage={setArchivo}
              accept=".pdf, .png, .jpg, .jpeg"
              tiposPermitidos={["application/pdf", "image/*"]}
              permiteImagen={true}
            />
          </Grid>
        </Grid>

        <Grid item {...gridSize} mt={1}>
          <Paper className="productos" >
            {/* <div className="linea" /> */}
            <Grid item {...gridSize} spacing={2} container justifyContent={'flex-end'}>
              <Grid item>
                <ActionsBar
                  onDownload={handleDowload}
                  onPrint={handlePrint}
                />
              </Grid>

            </Grid>
            <Grid item {...gridSize} mt={2} container justifyContent={'flex-end'}>
              <Typography variant={'h6'} fontWeight={'bold'}>{`TOTAL A PAGAR (+IVA): $${(dataOrdenCompra?.data.total! as any)}`}</Typography>
            </Grid>
            <SampleTablePagination
              columns={infoProductos}
              data={paginatedData}
              pagination={pagination}
              setPagination={setPagination}
              rowCount={productos.length}
            />
          </Paper>
        </Grid>
      </Grid>
      {isOpeModalRechazo && (
        <ScrollableDialogProps
          open={isOpeModalRechazo}
          title="Rechazar Orden Pedido"
          cancelTextBtn="Cancelar"
          confirmTextBtn="Rechazar"
          onCloseIcon={() => { setIsOpenModalRechazo(false), form.setValue('motivo_rechazo', '') }}
          onClose={() => { setIsOpenModalRechazo(false), form.setValue('motivo_rechazo', '') }}
          showRejectBtn={true}
          rejectBtnColor="error"
          rejectVariantBtn="outlined"
          onReject={handleUpdateMotivo}
          contentNode={
            <>
              <CustomAutocomplete<MotivoRechazo>
                label="Motivo"
                name="motivo_rechazo"
                options={(dataMotivoRechazo?.data.data) || []}
                isLoadingData={isLoadingMotivo}
                valueKey={"nombre"}
                actualValueKey={'codigo'}
                defaultValue={form.getValues().motivo_rechazo || ''}
                control={form.control}
                error={errors.motivo_rechazo}
                helperText={errors.motivo_rechazo?.message}
              /*   optionLabelForEdit={
                  dataMotivoRechazo?.data.data.find((item) => item.codigo === form.getValues().motivo_rechazo)
                    ?.id_motivo_rechazo?.toString() || ""
                } */
              />
            </>
          }
        />
      )
      }

      <CustomEmailDialog
        title="📧 Confirmación de envío!"
        open={isOpenModal2}
        setOpen={() => setIsOpenModal2(false)}
        message="¿Deseas enviar la orden al correo del proveedor?. Al confirmar, el documento será enviado automáticamente a los correos registrados. "
        fieldName="correos"
        fields={fields}
        form={form}
        append={append}
        remove={remove}
        editableIndex={editableIndex}
        setEditableIndex={setEditableIndex}

        onEditChange={(editable, /* index */) => {

          if (!editable) {
            return updateProveedor.mutate(
              {
                id: idEdit,
                data: {
                  email: form.getValues().correos?.[0].name,
                  contacto_email_1: form.getValues().correos?.[1].name,
                  contacto_email_2: form.getValues().correos?.[2].name
                } as any

              },
              {
                onSuccess: () => {
                  refetch();
                  setEditableIndex(null);
                }
              }
            )
          }
        }
        }
        onSave={(e) => {
          /* if(e.length>0){
            setEmailsProveedor(e)
          } */
          //setEmailsProveedor(e)
          //setIsOpenModal2(false)
          onSaveUpdate(e)
        }}

      />
    </>
  )
}